<template>
  <v-container>
    <v-toolbar color="primary" dark>
      <template v-slot:extension>
        <v-tabs fixed-tabs color="primary" active-class="active-tab">
          <v-tabs-slider color="#FDE700"></v-tabs-slider>
          <v-tab
            ref="members_list"
            key="members_list"
            :to="{ name: 'members_list', params: { site_key: $attrs.site_key } }"
          >
            Лица
          </v-tab>
          <v-tab
            key="members_group"
            :to="{ name: 'members_groups', params: { site_key: $attrs.site_key } }"
            >Группы</v-tab
          >
        </v-tabs>
      </template>
    </v-toolbar>
    <v-row column>
      <v-col cols="12">
        <router-view
          name="members"
          :site_key="$attrs.site_key"
          :site_title="$attrs.site_title"
        ></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'main',
  mounted() {
    this.$refs.members_list.click({})
  },
  update() {
    this.$refs.members_list.click({})
  },
}
</script>

<style scoped lang="scss">
.member {
  cursor: pointer;
  margin: 10px;
}

.member__info {
  margin: 10px;
}
</style>
